import React, { ReactNode } from "react";
import { Flex, Button, BoxProps, FlexProps } from "@thenounproject/lingo-core";
import styled from "styled-components";

interface FooterButtonProps {
  id?: string;
  text: string;
  onClick: () => void;
  disabled?: boolean;
  icon?: string;
}

type Props = {
  primary: FooterButtonProps;
  secondary?: FooterButtonProps;
  styleOverrides?: BoxProps & FlexProps;
  children?: ReactNode;
};

export const ModalFooterContainer = styled(Flex).attrs({
  py: "16px",
  px: "80px",
  variations: { "mq.s": { px: "16px" } },
  borderTop: "default",
  background: "grayLightest",
  alignItems: "center",
  justifyContent: "space-between",
  flexShrink: "0",
})`` as typeof Flex;

const ModalFooter: React.FC<Props> = ({ children, primary, secondary, styleOverrides }) => {
  return (
    <ModalFooterContainer {...styleOverrides}>
      <Flex>{children}</Flex>
      <Flex alignItems="center" flex="1" justifyContent="flex-end">
        {secondary ? (
          <Button
            id="modal-footer-secondary-button"
            buttonStyle="secondary"
            mr="s"
            {...secondary}
          />
        ) : null}

        <Button
          fullWidth={!secondary && !children}
          id={"modal-footer-primary-button"}
          {...primary}
        />
      </Flex>
    </ModalFooterContainer>
  );
};

export default ModalFooter;
